import Tipo2 from './Tipo2';
export default Tipo2;